(function(){
  var nav=document.getElementById('nav');
  var btn=document.getElementById('menu-btn'), menu=document.getElementById('menu');
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Calendar: hide past dates automatically
  (function(){
    var gigs=document.querySelectorAll('.gig[data-end]'); if(!gigs.length) return;
    var today=new Date(); today.setHours(0,0,0,0); var left=0;
    gigs.forEach(function(g){
      var p=g.dataset.end.split('-'); var end=new Date(+p[0],+p[1]-1,+p[2]);
      if(end<today){g.hidden=true;}else{left++;}
    });
    var weekly=document.querySelectorAll('.gig:not([data-end])').length;
    var empty=document.getElementById('gig-empty');
    if(!left&&!weekly&&empty){empty.hidden=false;}
  })();


  // Contact message grows with text
  (function(){var ta=document.getElementById('cf-msg'); if(!ta) return; ta.addEventListener('input',function(){ta.style.height='auto';ta.style.height=ta.scrollHeight+'px';});})();

  // Justify the name
  (function(){
    var h=document.querySelector('.hero h1.name'); if(!h) return;
    var a=h.querySelector('.l1'), b=h.querySelector('em');
    function fit(){
      [a,b].forEach(function(el){el.style.letterSpacing='';el.style.marginRight='';});
      var wa=a.getBoundingClientRect().width, wb=b.getBoundingClientRect().width;
      var short=wa<wb?a:b, diff=Math.abs(wa-wb), n=short.textContent.length;
      var cur=parseFloat(getComputedStyle(short).letterSpacing)||0, ls=cur+diff/(n-1);
      short.style.letterSpacing=ls+'px'; short.style.marginRight=(-ls+cur)+'px';
    }
    if(document.fonts&&document.fonts.ready){document.fonts.ready.then(fit);}
    fit(); window.addEventListener('resize',fit);
  })();

  // Sticky nav
  if(nav){
    var always=nav.classList.contains('solid-always');
    var onScroll=function(){nav.classList.toggle('solid', always||window.scrollY>40);};
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }

  // Mobile menu
  if(nav&&btn&&menu){
    var setMenu=function(open){nav.classList.toggle('open',open);btn.setAttribute('aria-expanded',open);btn.setAttribute('aria-label',open?'Close menu':'Open menu');};
    btn.addEventListener('click',function(){setMenu(!nav.classList.contains('open'));});
    menu.addEventListener('click',function(e){if(e.target.tagName==='A')setMenu(false);});
  }

  if('IntersectionObserver' in window){
    // Active section in nav (home page only)
    var links={};
    if(menu) menu.querySelectorAll('a[href^="#"]').forEach(function(a){links[a.getAttribute('href').slice(1)]=a;});
    if(links.music&&document.getElementById('discography')) links.discography=links.music;
    var spy=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting&&links[en.target.id]){
          Object.keys(links).forEach(function(k){links[k].classList.remove('active');});
          links[en.target.id].classList.add('active');
        }
      });
    },{rootMargin:'-45% 0px -50% 0px'});
    Object.keys(links).forEach(function(id){var s=document.getElementById(id); if(s) spy.observe(s);});

    // Reveal on scroll
    if(!reduce){
      var items=document.querySelectorAll('.album-copy,.stage,.gig,.feature,.press-list li,.bio-grid > *,.rec,.abooks li,.foot > *,.pcard');
      var rev=new IntersectionObserver(function(entries){
        entries.forEach(function(en){if(en.isIntersecting){var el=en.target;el.classList.add('shown');el.classList.remove('pending');rev.unobserve(el);}});
      },{rootMargin:'0px 0px -8% 0px'});
      items.forEach(function(el,i){
        if(el.getBoundingClientRect().top>window.innerHeight){el.classList.add('pending');el.style.transitionDelay=((i%4)*90)+'ms';rev.observe(el);}
      });
    }
  }

  // Modern Drummer viewer
  var lb=document.getElementById('md-review');
  if(lb){
    var lastFocus=null;
    var showTab=function(i){
      lb.querySelectorAll('.lb-tab').forEach(function(t){t.setAttribute('aria-selected', t.dataset.i==i);});
      lb.querySelectorAll('.lb-img').forEach(function(im){im.hidden = im.dataset.i!=i;});
      lb.querySelector('.lb-stage').scrollTop=0;
    };
    var openLb=function(e){e.preventDefault();lastFocus=document.activeElement;showTab(0);lb.hidden=false;document.body.style.overflow='hidden';lb.querySelector('.lb-close').focus();};
    var closeLb=function(){lb.hidden=true;document.body.style.overflow='';if(lastFocus)lastFocus.focus();};
    document.querySelectorAll('.js-md').forEach(function(a){a.addEventListener('click',openLb);});
    lb.querySelector('.lb-close').addEventListener('click',closeLb);
    lb.querySelectorAll('.lb-tab').forEach(function(t){t.addEventListener('click',function(){showTab(t.dataset.i);});});
    lb.addEventListener('click',function(e){if(e.target===lb||e.target.classList.contains('lb-stage'))closeLb();});
    lb.addEventListener('keydown',function(e){if(e.key==='Escape')closeLb();});
  }
})();
(function(){
  var b=document.getElementById('disco-more'), l=document.getElementById('recs'); if(!b||!l) return;
  b.addEventListener('click',function(){var open=l.classList.toggle('is-collapsed')===false;b.setAttribute('aria-expanded',open);b.textContent=open?'Show less':'View full discography';if(!open){document.getElementById('discography').scrollIntoView({behavior:'smooth'});}});
})();
// Section name under GARZONE while scrolling
(function(){
  var el=document.getElementById('mark-sec'); if(!el) return;
  var map=[['music','New Release'],['discography','Discography'],['reviews','Press'],['dates','Calendar'],['bio','Bio'],['tca','Books']];
  var secs=map.map(function(m){return [document.getElementById(m[0]),m[1]];}).filter(function(m){return m[0];});
  if(!secs.length) return;
  var tick=false;
  function upd(){tick=false;var y=window.innerHeight*0.35,label='';
    secs.forEach(function(m){var r=m[0].getBoundingClientRect();if(r.top<=y&&r.bottom>y)label=m[1];});
    if(el.textContent!==label)el.textContent=label;}
  window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(upd);}},{passive:true});
  upd();
})();